import {
  FileMagnifyingGlass,
  Folder,
  FolderOpen,
  Gear,
  PaperPlaneTilt,
  UserCircleCheck,
  Briefcase,
} from "@phosphor-icons/react";
import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { UsersThree } from "@phosphor-icons/react";
import { House } from "@phosphor-icons/react";
import { FileText } from "@phosphor-icons/react";
import { SlidersHorizontal } from "@phosphor-icons/react";
import { Question } from "@phosphor-icons/react";
import { SignOut } from "@phosphor-icons/react";
import SidebarLinkGroup from "../partials/sidebarlink";
import { Eye } from "@phosphor-icons/react";
import { EyeClosed } from "@phosphor-icons/react";
import { List } from "@phosphor-icons/react";
import { X } from "@phosphor-icons/react";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import useAuth from "../../hooks/useAuth";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../../components/ui/dialog";
import { Button } from "../ui/button";
import { UserList } from "@phosphor-icons/react";

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const trigger = useRef(null);
  const sidebar = useRef(null);
  const storedSidebarExpanded = localStorage.getItem("sidebar-expanded");
  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === "true"
  );
  const [openDialog, setOpenDialog] = useState(false);
  const { auth, logout } = useAuth();

  const handleNavigation = (event) => {
    event.preventDefault();
    const token = auth?.token;

    if (token) {
      try {
        navigate("/dashboard");
      } catch (error) {
        console.error("Invalid token:", error);
        navigate("/");
      }
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  useEffect(() => {
    localStorage.setItem("sidebar-expanded", sidebarExpanded);
    if (sidebarExpanded) {
      document.querySelector("body").classList.add("sidebar-expanded");
    } else {
      document.querySelector("body").classList.remove("sidebar-expanded");
    }
  }, [sidebarExpanded]);

  const handleLogout = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_APPROVAL_BACKEND_URL}/users/logout`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        localStorage.clear();
        await logout();
        navigate("/");
      } else {
        console.error("Failed to log out");
      }
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <div className=" mt-11">
      <div
        className={`fixed inset-0 bg-slate-900 bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${
          sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        aria-hidden="true"
      ></div>

      <div
        id="sidebar"
        ref={sidebar}
        className={`flex flex-col z-40 static left-auto top-auto translate-x-0 h-screen  overflow-y-auto no-scrollbar  w-20 sidebar-expanded:!w-64 xxl:!w-64 shrink-0 bg-white p-4 transition-all duration-200 ease-in-out ${
          sidebarOpen ? "translate-x-0" : "-translate-x-64"
        }`}
      >
        <div className="flex justify-between pr-3 mb-5 sm:px-2">
          <button
            ref={trigger}
            className="lg:hidden text-slate-500 hover:text-slate-400"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-controls="sidebar"
            aria-expanded={sidebarOpen}
          >
            <span className="sr-only">Close sidebar</span>
            <svg
              className="w-6 h-6 fill-current"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z" />
            </svg>
          </button>
        </div>

        <div className="space-y-2">
          <div>
            <h3 className="pl-3 text-xs font-semibold uppercase text-slate-500">
              <button onClick={() => setSidebarExpanded(!sidebarExpanded)}>
                <span
                  className="block sidebar-expanded:hidden w-6 text-center lg:block lg:sidebar-expanded:hidden xxl:hidden"
                  aria-hidden="true"
                >
                  <List size={22} className="text-black-500" />
                </span>
              </button>
              <button
                className="hidden sidebar-expanded:block lg:sidebar-expanded:block xxl:block float-end"
                onClick={() => setSidebarExpanded(!sidebarExpanded)}
              >
                {" "}
                <X size={20} className="text-black-500" />
              </button>
            </h3>
            <ul className="mt-3">
              <SidebarLinkGroup activecondition={pathname === "/dashboard"}>
                {() => {
                  return (
                    <React.Fragment>
                      <a
                        href="#0"
                        className={`block text-slate-200 truncate transition duration-150 ${
                          pathname.includes("dashboard")
                            ? "hover:text-slate-200"
                            : "hover:text-white"
                        }`}
                        onClick={handleNavigation}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex items-center ">
                            <House size={24} color="#2fca56" />
                            <span className="ml-3 text-sm font-medium text-gray-500 duration-200 lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100">
                              Dashboard
                            </span>
                          </div>
                        </div>
                      </a>
                      <div className="lg:hidden lg:sidebar-expanded:block xxl:block"></div>
                    </React.Fragment>
                  );
                }}
              </SidebarLinkGroup>

              {auth?.permissions?.includes("verify") && (
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/allapp" || pathname.startsWith("/approval/")
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <span
                          className={`block text-slate-200 truncate transition duration-150 ${
                            pathname === "/allapp" ||
                            pathname.startsWith("/approval/")
                              ? "hover:text-slate-200"
                              : "hover:text-white"
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <Link
                            to={"/allapp"}
                            className="flex items-center justify-between"
                          >
                            <div className="flex items-center">
                              <Folder size={24} color="#2fca56" />
                              <span className="ml-3 text-sm font-medium text-gray-500 duration-200 lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100">
                                Verifications
                              </span>
                            </div>
                          </Link>
                        </span>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              )}

              {auth?.permissions?.includes("approve") && (
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/adapplications" ||
                    pathname.startsWith("/adminaccept/")
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <a
                          href="#0"
                          className={`block text-slate-200 truncate transition duration-150 ${
                            pathname === "/adapplications" ||
                            pathname.startsWith("/adminaccept/")
                              ? "hover:text-slate-200"
                              : "hover:text-white"
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <Link
                            to={"/adapplications"}
                            className="flex items-center justify-between"
                          >
                            <div className="flex items-center">
                              <FolderOpen size={24} color="#2fca56" />
                              <span className="ml-3 text-sm font-medium text-gray-500 duration-200 lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100">
                                Approvals
                              </span>
                            </div>
                          </Link>
                        </a>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              )}

              {auth?.permissions?.includes("accept") && (
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/accapplications" ||
                    pathname.startsWith("/acceptmail/")
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <a
                          href="#0"
                          className={`block text-slate-200 truncate transition duration-150 ${
                            pathname === "/accapplications" ||
                            pathname.startsWith("/acceptmail/")
                              ? "hover:text-slate-200"
                              : "hover:text-white"
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <Link
                            to={"/accapplications"}
                            className="flex items-center justify-between"
                          >
                            <div className="flex items-center">
                              <PaperPlaneTilt size={24} color="#2fca56" />
                              <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100 duration-200 text-gray-500">
                                Acceptance
                              </span>
                            </div>
                          </Link>
                        </a>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              )}

              {auth?.permissions?.includes("accept") && (
                <SidebarLinkGroup activecondition={pathname === "/accepted"}>
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <Link
                          className={`block text-slate-200 truncate transition duration-150 ${
                            pathname.includes("accepted")
                              ? "hover:text-slate-200"
                              : "hover:text-white"
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                            navigate("/accepted");
                          }}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center">
                              <UserList size={24} color="#2fca56" />
                              <span className="ml-3 text-sm font-medium text-gray-500 duration-200 lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100">
                                Accepted Applicants
                              </span>
                            </div>
                          </div>
                        </Link>
                        {}
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              )}

              <div className="relative w-full m-auto mt-6 mb-6 border-2 "></div>

              <h3 className="pl-3 text-xs font-semibold uppercase text-slate-500">
                <span
                  className="hidden w-6 text-center lg:block lg:sidebar-expanded:hidden xxl:hidden"
                  aria-hidden="true"
                >
                  •••
                </span>
                {auth?.permissions?.includes("admin") && (
                  <span className="lg:hidden lg:sidebar-expanded:block xxl:block">
                    Settings
                  </span>
                )}
              </h3>
              {auth?.permissions?.includes("all") && (
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/vacancysettings" ||
                    pathname === "/adminsettings" ||
                    pathname === "/managevacancy" ||
                    pathname === "/managecourses"
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <a
                          href="#0"
                          className={`block text-slate-200 truncate transition duration-150 ${
                            pathname === "/vacancysettings" ||
                            pathname === "/adminsettings" ||
                            pathname === "/managevacancy" ||
                            pathname === "/managecourses"
                              ? "hover:text-slate-200"
                              : "hover:text-white"
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center">
                              <Gear size={24} color="#2fca56" />
                              <span className="ml-3 text-sm font-medium text-gray-500 duration-200 lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100">
                                Admin Settings
                              </span>
                            </div>
                            <div className="flex ml-2 -mt-1 shrink-0">
                              <svg
                                className={`w-3 h-3 shrink-0 ml-1 fill-current text-slate-400 ${
                                  open && "rotate-180"
                                }`}
                                viewBox="0 0 12 12"
                              >
                                <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                              </svg>
                            </div>
                          </div>
                        </a>
                        <div className="lg:hidden lg:sidebar-expanded:block xxl:block">
                          <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                            <li className="mb-1 last:mb-0">
                              <NavLink
                                end
                                to={"/vacancysettings"}
                                className={({ isActive }) =>
                                  "block transition duration-150 truncate " +
                                  (isActive
                                    ? "text-green-500"
                                    : "text-gray-300 hover:text-green-600")
                                }
                              >
                                <Link to={"/vacancysettings"}>
                                  <span className="text-sm font-medium duration-200 lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100">
                                    Vacancies
                                  </span>
                                </Link>
                              </NavLink>
                            </li>
                            <li className="mb-1 last:mb-0">
                              <NavLink
                                end
                                to="/adminsettings"
                                className={({ isActive }) =>
                                  "block transition duration-150 truncate " +
                                  (isActive
                                    ? "text-green-500"
                                    : "text-gray-300 hover:text-green-600")
                                }
                              >
                                <span className="text-sm font-medium duration-200 lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100">
                                  Users
                                </span>
                              </NavLink>
                            </li>
                            <li className="mb-1 last:mb-0">
                              <NavLink
                                end
                                to="/managevacancy"
                                className={({ isActive }) =>
                                  "block transition duration-150 truncate " +
                                  (isActive
                                    ? "text-green-500"
                                    : "text-gray-300 hover:text-green-600")
                                }
                              >
                                <span className="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100 duration-200">
                                  Create Vacancies
                                </span>
                              </NavLink>
                            </li>
                            <li className="mb-1 last:mb-0">
                              <NavLink
                                end
                                to="/managecourses"
                                className={({ isActive }) =>
                                  "block transition duration-150 truncate " +
                                  (isActive
                                    ? "text-green-500"
                                    : "text-gray-300 hover:text-green-600")
                                }
                              >
                                <span className="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100 duration-200">
                                  Manage Courses
                                </span>
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              )}
            </ul>
          </div>
          <div>
            <ul className="mt-3">
              <SidebarLinkGroup>
                {(handleClick, open) => {
                  return (
                    <React.Fragment>
                      <Link
                        to={"/help"}
                        className={`block text-slate-200 truncate transition duration-150 ${
                          open ? "hover:text-slate-200" : "hover:text-white"
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          sidebarExpanded
                            ? handleClick()
                            : setSidebarExpanded(true);
                          navigate("/help");
                        }}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex items-center">
                            <Question size={24} color="#2fca56" />
                            <span className="ml-3 text-sm font-medium text-gray-500 duration-200 lg:opacity-0 lg:sidebar-expanded:opacity-100 xxl:opacity-100">
                              Help
                            </span>
                          </div>
                        </div>
                      </Link>
                      {}
                    </React.Fragment>
                  );
                }}
              </SidebarLinkGroup>
            </ul>

            <ul className="mt-3">
              <Dialog open={openDialog} onOpenChange={handleCloseDialog}>
                <DialogContent className="sm:max-w-[425px]">
                  <DialogHeader>
                    <DialogTitle className="text-2xl font-semibold mb-4">
                      Confirm Log out
                    </DialogTitle>
                    <DialogDescription className="text-base mt-2">
                      You are about to log Out Proceed?
                    </DialogDescription>
                  </DialogHeader>
                  <DialogFooter className="mt-6 space-x-2">
                    <Button
                      className="px-6 py-2 text-white bg-red-500 hover:bg-red-600 transition-colors"
                      onClick={(e) => {
                        handleLogout();
                      }}
                    >
                      Log out
                    </Button>
                    <Button
                      variant="outline"
                      className="px-6 py-2 border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
                      onClick={handleCloseDialog}
                    >
                      Cancel
                    </Button>
                  </DialogFooter>
                </DialogContent>
              </Dialog>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
